
export enum SUBFOLDERS_TYPES {
  FORMS = 'formularios',
  PRODUCT_SHEETS = 'ficha-productos',
  PRODUCT_MANUALS = 'manuales-producto',
  NOTES = 'notas-red',
  SSN_RESOLUTIONS = 'resolucion-ssn',
  CONTACT_INDEX = 'indice-contactos',
  BROCHURE_CAUTION = 'brochure-seguro-caucion',
  TUTORIALS = 'tutoriales',
}